import { Component, OnInit } from '@angular/core';
import { HelperService } from '../../services/helper.service';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-adhoc-service-sidenav',
  templateUrl: './adhoc-service-sidenav.component.html',
  styleUrls: ['./adhoc-service-sidenav.component.scss']
})
export class AdhocServiceSidenavComponent implements OnInit {
  isUAT = false;

  constructor(
    private helperService: HelperService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    const savedEnv = this.helperService.getStoredValue('ecase_env', 'prod');
    this.isUAT = savedEnv === 'uat';
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  toggleEnvironment(): void {
    this.isUAT = !this.isUAT;
    const newEnv = this.isUAT ? 'uat' : 'prod';
    this.helperService.storeValue('ecase_env', newEnv);
    window.location.reload();
  }
}
